import styled from 'styled-components';
import { border, BorderProps, color, ColorProps } from 'styled-system';

type StyledOTPprops = {
  outlineColor?: string;
} & BorderProps &
  ColorProps;

export const StyledOTP = styled.input<StyledOTPprops>(
  border,
  color,
  {
    width: '100% !important',
    padding: '0px !important',
    color: 'rgb(39, 157, 46) !important',
    fontSize: '40px !important',
    height: '50px !important',
    border: '0px',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    userSelect: 'none',
    caretColor: 'transparent',
    '&::selection': {
      backgroundColor: 'transparent',
    },
    textAlign: 'center',
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  (props) => ({
    'outline-color': props.outlineColor,
  })
);
